import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AnyAction } from 'redux';
import { ThunkAction } from '@reduxjs/toolkit';

export enum FilterType {
  Checkbox = 'checkbox',
}

interface BaseCheckboxEntry {
  label: string;
}

type AppThunk = ThunkAction<any, any, unknown, AnyAction>;

interface CheckboxEntry extends BaseCheckboxEntry {
  inputId: string;
  filterType: FilterType.Checkbox;
  dispatchAction: () => AppThunk;
}

export const FilterLookup: Partial<Record<Filters, CheckboxEntry>> = {
  onlyRecentlyViewed: {
    inputId: 'filter-recently-viewed',
    label: I18n.t('shared.asset_browser.filters.recently_viewed.label'),
    dispatchAction: filters.toggleRecentlyViewed,
    filterType: FilterType.Checkbox,
  },
  enrolledInArchival: {
    inputId: 'filter-enrolled-in-archival',
    label: I18n.t('shared.asset_browser.filters.enrolled_in_archival.label'),
    dispatchAction: filters.toggleEnrolledInArchival,
    filterType: FilterType.Checkbox,
  },
  approvalStatus: {
    inputId: 'filter-awaiting-approval',
    label: I18n.t('shared.asset_browser.filters.awaiting_approval'),
    dispatchAction: filters.toggleAwaitingApproval,
    filterType: FilterType.Checkbox,
  },
  showInternalTargetAudience: {
    inputId: 'filter-internal-target-audience',
    label: I18n.t('shared.asset_browser.filters.approval_types.internal'),
    dispatchAction: filters.toggleInternalTargetAudience,
    filterType: FilterType.Checkbox,
  },
  showPublicTargetAudience: {
    inputId: 'filter-public-target-audience',
    label: I18n.t('shared.asset_browser.filters.approval_types.public'),
    dispatchAction: filters.togglePublicTargetAudience,
    filterType: FilterType.Checkbox,
  },
};
